module.exports = __webpack_public_path__ + "img/alex-modes.f3096f81.jpg";